/* JUSTPRETTYCHIC V14 native menu keyboard accessibility. */
(function () {
  'use strict';

  var bootAttempts = 0;
  var drawerBootAttempts = 0;
  var utilityDrawerBootAttempts = 0;
  var suppressNextFocusOpen = false;

  function ensureContactHeading() {
    if (!/^\/pages\/contact-justprettychic\/?$/.test(window.location.pathname)) return;
    var main = document.querySelector('main');
    if (!main) return;
    var headings = main.querySelectorAll('h1, h2, h3, h4, h5, h6');
    var heading = null;
    var index;

    for (index = 0; index < headings.length; index += 1) {
      if ((headings[index].textContent || '').replace(/\s+/g, ' ').trim() === 'Customer Care') {
        heading = headings[index];
        break;
      }
    }

    if (!heading || heading.tagName === 'H1') return;

    var replacement = document.createElement('h1');
    Array.prototype.slice.call(heading.attributes).forEach(function (attribute) {
      replacement.setAttribute(attribute.name, attribute.value);
    });
    if (!replacement.className) replacement.className = 'h3';
    while (heading.firstChild) replacement.appendChild(heading.firstChild);
    heading.parentNode.replaceChild(replacement, heading);
  }

  function bootContactSemantics() {
    if (!/^\/pages\/contact-justprettychic\/?$/.test(window.location.pathname)) return;
    ensureContactHeading();
    var target = document.querySelector('main') || document.body;
    if (!target || typeof MutationObserver === 'undefined') return;
    var contactObserver = new MutationObserver(ensureContactHeading);
    contactObserver.observe(target, {childList: true, subtree: true});
    window.setTimeout(function () {
      ensureContactHeading();
      contactObserver.disconnect();
    }, 5000);
  }

  function bootDrawerSemantics() {
    var trigger = document.querySelector('[data-js-popup-button="navigation"]');
    var drawer = document.getElementById('JpcNavigationDrawer');
    var popup = drawer && drawer.closest('.js-popup');
    var popupBody = drawer && drawer.closest('.popup__body');

    if (!trigger || !drawer || !popup || !popupBody) {
      drawerBootAttempts += 1;
      if (drawerBootAttempts < 160) window.setTimeout(bootDrawerSemantics, 50);
      return;
    }

    if (trigger.getAttribute('data-jpc-drawer-a11y-ready') === 'true') return;
    trigger.setAttribute('data-jpc-drawer-a11y-ready', 'true');

    function syncDrawerState() {
      var open = popup.classList.contains('active') &&
        popup.classList.contains('show') &&
        popupBody.classList.contains('show') &&
        popupBody.classList.contains('visible');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    }

    var drawerObserver = new MutationObserver(syncDrawerState);
    drawerObserver.observe(popup, {attributes: true, attributeFilter: ['class']});
    drawerObserver.observe(popupBody, {attributes: true, attributeFilter: ['class']});
    syncDrawerState();
  }

  function bootUtilityDrawerSemantics() {
    var popup = document.querySelector('.js-popup');
    var names = ['services', 'account', 'cart'];

    if (!popup) {
      utilityDrawerBootAttempts += 1;
      if (utilityDrawerBootAttempts < 160) window.setTimeout(bootUtilityDrawerSemantics, 50);
      return;
    }

    names.forEach(function (name) {
      var popupBody = popup.querySelector('[data-js-popup-name="' + name + '"]');
      var triggers = Array.prototype.slice.call(
        document.querySelectorAll('[data-js-popup-button="' + name + '"]')
      );

      if (!popupBody || !triggers.length || popupBody.getAttribute('data-jpc-utility-a11y-ready') === 'true') return;
      popupBody.setAttribute('data-jpc-utility-a11y-ready', 'true');

      var activeTrigger = null;
      var wasOpen = false;

      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.addEventListener('click', function () {
          activeTrigger = trigger;
        });
      });

      function syncUtilityState() {
        var open = popup.classList.contains('active') &&
          popup.classList.contains('show') &&
          popupBody.classList.contains('show') &&
          popupBody.classList.contains('visible');

        triggers.forEach(function (trigger) {
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        popupBody.setAttribute('aria-hidden', open ? 'false' : 'true');

        if (open && !wasOpen) {
          window.setTimeout(function () {
            var close = popupBody.querySelector('[data-js-popup-close]');
            if (close && typeof close.focus === 'function') close.focus();
          }, 180);
        } else if (!open && wasOpen && activeTrigger && typeof activeTrigger.focus === 'function') {
          activeTrigger.focus();
        }
        wasOpen = open;
      }

      var utilityObserver = new MutationObserver(syncUtilityState);
      utilityObserver.observe(popup, {attributes: true, attributeFilter: ['class']});
      utilityObserver.observe(popupBody, {attributes: true, attributeFilter: ['class']});
      syncUtilityState();
    });
  }

  function boot() {
    var menu = document.querySelector('.js-menu.menu--main');

    if (!menu) {
      bootAttempts += 1;
      if (bootAttempts < 160) window.setTimeout(boot, 50);
      return;
    }

    if (menu.getAttribute('data-jpc-keyboard-ready') === 'true') return;
    menu.setAttribute('data-jpc-keyboard-ready', 'true');

  var topItems = Array.prototype.slice.call(
    menu.querySelectorAll('.menu__panel > .menu__item--has-children')
  );

  function isDesktop() {
    return window.matchMedia('(min-width: 1025px)').matches;
  }

  function directTrigger(item) {
    return item && item.querySelector(':scope > [data-jpc-menu-trigger]');
  }

  function directPanel(item) {
    return item && item.querySelector(':scope > .menu__megamenu, :scope > .menu__dropdown');
  }

  function firstFocusable(panel) {
    return panel && panel.querySelector(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  }

  function syncItem(item) {
    var trigger = directTrigger(item);
    var panel = directPanel(item);
    if (!trigger || !panel) return;
    trigger.setAttribute(
      'aria-expanded',
      panel.classList.contains('show') || item.classList.contains('open') ? 'true' : 'false'
    );
  }

  function syncAll() {
    topItems.forEach(syncItem);
  }

  function openItem(item, focusPanel) {
    var trigger = directTrigger(item);
    var panel = directPanel(item);
    if (!isDesktop() || !trigger || !panel) return;
    topItems.forEach(function (otherItem) {
      if (otherItem === item) return;
      var otherPanel = directPanel(otherItem);
      var otherTrigger = directTrigger(otherItem);
      otherItem.classList.remove('open');
      if (otherPanel) otherPanel.classList.remove('show', 'animate', 'visible', 'overflow-hidden');
      if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
    });
    item.classList.add('open');
    panel.classList.add('show', 'animate', 'visible');
    panel.classList.remove('overflow-hidden');
    panel.style.removeProperty('height');
    trigger.setAttribute('aria-expanded', 'true');
    if (focusPanel) {
      window.requestAnimationFrame(function () {
        var first = firstFocusable(panel);
        if (first) first.focus();
      });
    }
  }

  function closeItem(item) {
    var trigger = directTrigger(item);
    var panel = directPanel(item);
    if (!trigger || !panel) return;
    item.classList.remove('open');
    panel.classList.remove('show', 'animate', 'visible', 'overflow-hidden');
    panel.style.removeProperty('height');
    trigger.setAttribute('aria-expanded', 'false');
  }

  menu.addEventListener('focusin', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-jpc-menu-trigger]');
    var item = trigger && trigger.parentElement;
    if (!item || topItems.indexOf(item) === -1) return;
    if (suppressNextFocusOpen) {
      suppressNextFocusOpen = false;
      return;
    }
    openItem(item, false);
  });

  menu.addEventListener('focusout', function (event) {
    var item = event.target.closest && event.target.closest('.menu__panel > .menu__item--has-children');
    if (!item || (event.relatedTarget && item.contains(event.relatedTarget))) return;
    closeItem(item);
  });

  menu.addEventListener('keydown', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-jpc-menu-trigger]');
    var triggerItem = trigger && trigger.parentElement;
    if (
      trigger &&
      topItems.indexOf(triggerItem) !== -1 &&
      (event.key === 'ArrowDown' || event.key === 'Down')
    ) {
      event.preventDefault();
      event.stopPropagation();
      openItem(triggerItem, true);
      return;
    }

    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    var item = event.target.closest && event.target.closest('.menu__panel > .menu__item--has-children');
    var itemTrigger = directTrigger(item);
    var panel = directPanel(item);
    if (!item || !itemTrigger || !panel || itemTrigger.getAttribute('aria-expanded') !== 'true') return;
    event.preventDefault();
    event.stopPropagation();
    suppressNextFocusOpen = true;
    closeItem(item);
    itemTrigger.focus();
  });

  var observer = new MutationObserver(syncAll);
  topItems.forEach(function (item, index) {
    var panel = directPanel(item);
    var trigger = directTrigger(item);
    if (!panel || !trigger) return;
    if (!panel.id) panel.id = 'JpcMainMenuPanel-' + (index + 1);
    trigger.setAttribute('aria-controls', panel.id);
    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    observer.observe(item, {attributes: true, attributeFilter: ['class']});
    observer.observe(panel, {attributes: true, attributeFilter: ['class']});
  });

    window.addEventListener('resize', syncAll, {passive: true});
    syncAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootContactSemantics, {once: true});
    document.addEventListener('DOMContentLoaded', bootDrawerSemantics, {once: true});
    document.addEventListener('DOMContentLoaded', bootUtilityDrawerSemantics, {once: true});
    document.addEventListener('DOMContentLoaded', boot, {once: true});
  } else {
    bootContactSemantics();
    bootDrawerSemantics();
    bootUtilityDrawerSemantics();
    boot();
  }
})();
